export default __webpack_public_path__ + "static/media/farm.6c610f20.svg";